import { z } from 'zod';

import { buildQueryString } from '../../utils/querystring';
import { makeEndpoint } from '../common';

export enum SupportedCurrency {
  AED = 'AED',
  ALL = 'ALL',
  AMD = 'AMD',
  AOA = 'AOA',
  ARS = 'ARS',
  AUD = 'AUD',
  AZN = 'AZN',
  BAM = 'BAM',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BSD = 'BSD',
  BTN = 'BTN',
  BWP = 'BWP',
  CAD = 'CAD',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CZK = 'CZK',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EGP = 'EGP',
  ETB = 'ETB',
  EUR = 'EUR',
  GBP = 'GBP',
  GHS = 'GHS',
  GMD = 'GMD',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KHR = 'KHR',
  KRW = 'KRW',
  KWD = 'KWD',
  KZT = 'KZT',
  LAK = 'LAK',
  LKR = 'LKR',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MNT = 'MNT',
  MOP = 'MOP',
  MUR = 'MUR',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NOK = 'NOK',
  NZD = 'NZD',
  OMR = 'OMR',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RWF = 'RWF',
  SAR = 'SAR',
  SEK = 'SEK',
  SGD = 'SGD',
  THB = 'THB',
  TND = 'TND',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VND = 'VND',
  XAF = 'XAF',
  XCD = 'XCD',
  XOF = 'XOF',
  ZAR = 'ZAR',
}

export const getSupportedCurrencySymbols = ({ baseCurrency }: { readonly baseCurrency?: string } = {}) => {
  const normalizedBaseCurrency = baseCurrency?.toUpperCase();
  return Object.values(SupportedCurrency).filter((currency) => currency !== normalizedBaseCurrency);
};

export const PostCurrencyRatesEndpoint = makeEndpoint({
  method: 'POST',
  url: () => '/currency-conversion-rates',
  requestSchema: z.void(),
  responseSchema: z.void(),
});

export const GetConvertedCurrencyQuerySchema = z.object({
  fromCurrency: z.nativeEnum(SupportedCurrency),
  toCurrency: z.nativeEnum(SupportedCurrency),
  amount: z.coerce.number(),
});

export const GetConvertedCurrencyResponseSchema = z.object({
  convertedAmount: z.number(),
});

export const GetConvertedCurrencyEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }: { query: z.input<typeof GetConvertedCurrencyQuerySchema> }) =>
    `/convert-currency?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: GetConvertedCurrencyQuerySchema,
  responseSchema: GetConvertedCurrencyResponseSchema,
});
